import { render } from "./LicenseAndCertificate.vue?vue&type=template&id=00d7ff6c"
import script from "./LicenseAndCertificate.vue?vue&type=script&lang=js"
export * from "./LicenseAndCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__